import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CheckCircle2Icon, XIcon } from "lucide-react";
import { SPANISH_NAMES, SPANISH_CITIES } from "../data/content";
function rand<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
export function PurchasePopup() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: "",
    city: "",
    mins: 3
  });
  useEffect(() => {
    let hideTimer: ReturnType<typeof setTimeout>;
    const show = () => {
      setData({
        name: rand(SPANISH_NAMES),
        city: rand(SPANISH_CITIES),
        mins: Math.floor(Math.random() * 12) + 1
      });
      setVisible(true);
      hideTimer = setTimeout(() => setVisible(false), 5000);
    };
    const first = setTimeout(show, 4000);
    const interval = setInterval(show, 15000);
    return () => {
      clearTimeout(first);
      clearTimeout(hideTimer);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-197" data-mp="164xqn44510nq">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 24
    }} transition={{
      duration: 0.3
    }} className="fixed bottom-4 left-3 right-3 z-50 mx-auto max-w-sm" data-id="element-198" data-mp="163wh542rsm84">
          <div className="flex items-start gap-3 rounded-2xl border border-[#d4ff00]/40 bg-[#0b0b0b] p-3.5 shadow-2xl" data-id="element-199" data-mp="1ay0pnrrop2bb">
            <div className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#d4ff00]/15" data-id="element-200" data-mp="n97mpbcn9u77">
              <CheckCircle2Icon className="h-5 w-5 text-[#d4ff00]" data-id="element-201" data-mp="iaeh053ln7hl" />
            </div>
            <div className="flex-1" data-id="element-202" data-mp="x380s2pwm9s2">
              <p className="text-[13px] font-semibold text-white" data-id="element-203" data-mp="s5okyydk5oy0">
                {data.name} de {data.city}
              </p>
              <p className="text-[12px] leading-snug text-white/60" data-id="element-204" data-mp="28j508kvdcc3j">
                acaba de comprar{" "}
                <span className="font-semibold text-[#d4ff00]" data-id="element-205" data-mp="23kv3w6xwr5gc">
                  Padel Zurdo Pro
                </span>
              </p>
              <p className="mt-1 text-[11px] text-white/40" data-id="element-206" data-mp="2fno0b7cpz5yk">
                hace {data.mins} min · compra verificada ✅
              </p>
            </div>
            <button type="button" onClick={() => setVisible(false)} className="text-white/40 hover:text-white" aria-label="Cerrar" data-id="element-207" data-mp="2ko29isq24ly6">
              <XIcon className="h-4 w-4" data-id="element-208" data-mp="1rzmxmf282jr2" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}